import styled from '@emotion/styled'
import { ifElse, always, prop } from 'ramda'
import { themeColor } from 'utils/styles'
import { getDimensionStyle } from 'components/patterns/dimensions'

export const StyledSpan = styled.span((props) => {
  const { size, theme } = props
  return `
    ${getDimensionStyle({ size, theme, doHeight: false })}
    > .postscript {
      padding-left: 2px;
    }
  `
})

export const StyledValue = styled.span`
  color: ${ifElse(
    prop('styleAsError'),
    themeColor('paragraphErrorColor'),
    always('inherit')
  )};
`
